import Survey from '../views/survey/Survey.vue'
import Survey2 from '../views/survey2/Survey.vue'
import SingaporeSurvey from '../views/surveys/singapore/Survey.vue'
import SydneySurvey from '../views/surveys/sydney/Survey.vue'
import SapporoSurvey from '../views/surveys/sapporo/Survey.vue'

export default [
  {
    path: '/survey/PF22/:wave_number',
    name: 'croatia-survey',
    component: Survey
  },
  {
    path: '/survey/CM/:wave_number',
    name: 'chiangmai-survey',
    component: Survey2
  },
  {
    path: '/survey/SG/:wave_number',
    name: 'singapore-survey',
    component: SingaporeSurvey
  },
  {
    path: '/survey/Sydney/:wave_number',
    name: 'sydney-survey',
    component: SydneySurvey
  },
  {
    path: '/survey/Sapporo/:wave_number',
    name: 'sapporo-survey',
    component: SapporoSurvey
  },
  ]


// WEBPACK FOOTER //
// ./src/router/survey.js